import React, { ComponentType } from 'react';
import { LanguageContext, LanguageContextApi } from '.';

export interface WithLangProps {
  lang: LanguageContextApi;
}

export function withLang<Props = {}>(
  WrappedComponent: ComponentType<Props & WithLangProps>
) {
  const WrapperComponent: ComponentType<Props> = props => (
    <LanguageContext.Consumer>
      {lang => <WrappedComponent {...props} lang={lang} />}
    </LanguageContext.Consumer>
  );
  WrapperComponent.displayName = `withLang(${WrappedComponent.displayName ||
    WrappedComponent.name ||
    'Component'})`;
  return WrapperComponent;
}
